export default __webpack_public_path__ + "static/media/img-adult.3d7942f2.png";